export default __webpack_public_path__ + "1799c5924051d70e456b6ec25621da91.jpg";